import { useAct } from 'FlowTaker/store'
import CustomContent from 'FlowBuilder/components/ActionViews/Custom/CustomContent'
import TemplateRender from 'FlowBuilder/components/ActionViews/TemplateRender'
import useRenderContext from 'FlowTaker/hooks/useRenderContext'

export default function CustomAction({ actionId, surveyId }) {
  const act = useAct()
  const bodyHtml = useSel(s => s.taker.flow.template.body)
  const context = useRenderContext({ actionId })
  const action = useSel(s => s.taker.flow.actions.find(a => a.id === actionId) || {})

  const handleSubmit = (data) => {
    return act.taker.completeAction({ actionId })
  }

  const componentMap = useMemo(() => ({
    TakeSurveyForm: <>
      <CustomContent action={action} onSubmit={handleSubmit} />
    </>,
  }), [surveyId])

  return <div>
    <TemplateRender htmlContent={bodyHtml} componentMap={componentMap} context={context} />
  </div>
}
